type ProviderDeepLinkHeader = {
  [key: string]: string,
}

export type ProviderDeepLinkModel = {
  headers?: ProviderDeepLinkHeader[],
  id?: string,
  link_text?: string,
  method?: 'GET' | 'POST',
  status_id?: number,
  title?: string,
  url?: string,
}

const state = {
  headers: [],
  id: undefined,
  link_text: 'Manage Item',
  method: 'GET',
  status_id: undefined,
  title: '',
  url: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'url' },
]

export default state
